<template>
  <div class="absolute" ref="divSize">
    <custom-popover ref="popover" :style="{ left: left + 'px', top: top + 8 + 'px' }" :backdrop="true">
      <div class="create-synonym-popover" :class="{ 'move-left': moveLeft }">

        <div v-if="loadingSuggestions">
          <div class="loading">
            <span>
              {{ $t("find-suggestions") }}
            </span>
            <span>
              <i class="fa-light fa-circle-notch fa-spin"></i>
            </span>
          </div>
        </div>
        <synonym-list
          v-else
          @syn-list="formatSynList"
          @save-list="onSave"
          :aiSuggestions="aiSuggestions"
          :synonymInstance="synonymInst"
          :localSynonym="localSynonym"
          :selectedText="selectedText"
          :examples="localSynonym ? null : examples"
          @converted-to-global="(globalSynonym) => $emit('converted-to-global', globalSynonym)"
          @converted-to-local="convertToLocalSyn"
          @format-syn="formatSyn = !formatSyn"
          @paranthesis-status="(status) => canSave = !status"
        />
        <synonym-format-selector
          v-if="!localSynonym && formatSyn"
          class="synonym-format"
          :synonym="synonymInst"
          :formatting="formatting"
          :formatType="'text'"
          :updatedFormat="updatedFormat"
          @format-changed="handleFormatChange"
        />
        <div class="save-footer" :class="{'can-save':  canSave && !loadingSuggestions}">
          <div class="cancel" @click="onClose">
            {{ $t("editor-expression.cancel") }}
            <i class="fa-light fa-times"></i>
          </div>
          <div class="save" @click="onSave">
            {{ $t("editor-expression.save") }}
            <i class="fa-light fa-check"></i>
          </div>
        </div>
      </div>
    </custom-popover>
  </div>
</template>

<script>
import SynonymList from "@/components/SynonymList";
import SynonymFormatSelector from "@/components/SynonymFormatSelector";
import CustomPopover from "@/components/CustomPopover";
import EventBus from "@/assets/js/eventBus.js";
export default {
  name: "CreateSynonymPopover",
  props: {
    synonymInstance: { type: Object },
    formatting: String,
    localSynonym: Boolean,
    top: Number,
    left: Number,
    moveLeft: Boolean,
    selectedText: String,
    synonymSuggestions: Boolean,
  },
  data() {
    return {
      canSave: true,
      selectedVariable: null,
      hasChanges: false,
      formattedSynList: "",
      formatSyn: true,
      formatChanged: false,
      updatedFormat: this.formatting,
      examples: [],
      synonymConverted: false,
      aiSuggestions: [],
      loadingSuggestions: false,
    };
  },
  methods: {
    convertToLocalSyn(){
      this.synonymConverted = true
      this.formatSyn = false
    },
    handleFormatChange(format) {
      this.updatedFormat = format;
    },
    formatSynList(list) {
      if (list.length == 0) {
        this.$emit("synonym-edited", "");
      } else {
        this.hasChanges = true;
        list = list.map((i) => "|" + i);
        list[0] = list[0].substring(1);
        this.formattedSynList = list.join("");
        this.$emit("synonym-edited", this.formattedSynList);
      }
    },
    onSave() {
      if (this.synonymConverted) {
        this.$emit("synonym-updated", this.formattedSynList);
      } else {
        if (!this.localSynonym && !this.hasChanges) this.$emit("close");
        if (!this.localSynonym && !this.formatChanged) {
          this.$emit("format-updated", this.synonymInstance, this.updatedFormat);
        } else {
          this.$emit("synonym-updated", this.formattedSynList);
        }
      }
    },
    onClose() {
      this.$emit("close");
    },

    loadSelectedFormatExamples() {
      this.$store
        .dispatch("getSynonymFormatExamples", {
          synonym: this.synonymInstance,
          formats: [this.updatedFormat],
          all: true,
        })
        .then((res) => {
          this.examples = res.map((r) => r.result);
        });
    },

    getSynonymSuggestions() {
      this.loadingSuggestions = true;
      this.$store.dispatch("getSynonymSuggestions", this.selectedText).then((response) => {
        this.aiSuggestions = response;
      }).catch((e) => {
        this.aiSuggestions = [];
      }).finally(() => {
        this.loadingSuggestions = false;
      })
    },
  },
  computed: {
    synonymInst() {
      return this.synonymInstance;
    },
  },
  mounted(){
    if(this.synonymSuggestions) this.getSynonymSuggestions()
  },
  watch: {
    updatedFormat: {
      immediate: true,
      handler() {
        if (!this.localSynonym && this.synonymInstance.synonyms.length > 0) {
          this.loadSelectedFormatExamples();
        }
      },
    }
  },
  created() {
    EventBus.$emit("close_preview");
  },
  destroyed() {
    EventBus.$emit("open_preview");
  },
  components: {
    SynonymList,
    CustomPopover,
    SynonymFormatSelector,
  },
};
</script>

<style lang="less">
.absolute {
  position: absolute;
  top: 10px;
}
.custom-popover {
  position: fixed;
  z-index: 102;
  .create-synonym-popover {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.25);
    position: fixed;
    width: 300px;
    top: 70px;
    // left: calc(100% - 388px);
    left: calc(100% - 388px + 68px);
    background: #fff;
    min-width: 250px;
    max-height: calc(100% - 85px);
    border-radius: var(--standard-border-radius);
    .save-err{
      padding-left: 20px;
    }
    .save-footer{
      border-radius: 0 0 10px 10px;
    }
  }
  .variable-list {
    width: 300px;
    position: relative;
    padding-top: 10px;
    .variable-list-wrapper {
      max-height: 200px;
    }
  }
  .variable-format {
    width: 300px;
    padding: 0px 0;
    position: relative;
    background: #f1f1f1;
    flex-grow: 1;
    overflow: hidden;
  }

  .loading{
    min-height: 100px;
    color: var(--ai-secondary);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
}
.create-synonym-popover.move-left {
  left: calc(100% - 590px);
}
</style>
